import { shikiToMonaco } from '@shikijs/monaco'
import * as monaco from 'monaco-editor'
import { createHighlighter } from 'shiki'

export const initializeMonaco = async (backgroundColor?: string) => {
  const highlighter = await createHighlighter({
    langs: ['xml', 'markdown', 'yaml', 'toml', 'json', 'java', 'csv'],
    langAlias: {
      raml: 'yaml',
      dataweave: 'yaml',
      dwl: 'yaml',
      example: 'yaml',
      task: 'yaml'
    },
    themes: ['github-light', 'min-dark']
  })

  monaco.languages.register({ id: 'json' })
  monaco.languages.register({ id: 'xml' })
  monaco.languages.register({ id: 'dataweave' })
  monaco.languages.register({ id: 'dwl' })
  monaco.languages.register({ id: 'csv' })
  monaco.languages.register({ id: 'yaml' })

  shikiToMonaco(highlighter as any, monaco as any)
  monaco.editor.defineTheme('github-light', {
    base: 'vs',
    inherit: true,
    rules: [
      // Override URL colors to be blue instead of red
      { token: 'string.unquoted.url', foreground: '0047ab' },
      { token: 'string.quoted.url', foreground: '0047ab' },
      { token: 'string.url', foreground: '0047ab' },
      { token: 'url', foreground: '0047ab' },
      { token: 'markup.underline.link', foreground: '0047ab' },
      { token: 'markup.link', foreground: '0047ab' },
      { token: 'string.other.link', foreground: '0047ab' },
      { token: 'keyword.other.url', foreground: '0047ab' },
      // Additional URL-related tokens that might be red
      { token: 'constant.other.url', foreground: '0047ab' },
      { token: 'meta.link.inet', foreground: '0047ab' },

      // -------------------------------
      // String literal color overrides
      // -------------------------------
      // General string tokens
      { token: 'string', foreground: '0047ab' },
      { token: 'string.quoted', foreground: '0047ab' },
      { token: 'string.quoted.single', foreground: '0047ab' },
      { token: 'string.quoted.double', foreground: '0047ab' },
      { token: 'string.interpolated', foreground: '0047ab' },
      { token: 'string.template', foreground: '0047ab' },
      { token: 'string.regexp', foreground: '0047ab' }
    ],
    colors: {
      'editor.background': backgroundColor ?? '#ffffff'
    }
  })
}

export const MONACO_COMMON_OPTIONS = {
  minimap: { enabled: false },
  diffCodeLens: true,
  fontFamily: 'Menlo, Monaco, "Courier New", monospace',
  fontSize: 12,
  language: 'xml',
  theme: 'github-light',
  cursorBlinking: 'blink',
  cursorStyle: 'line',
  cursorWidth: 1,
  renderWhitespace: 'all',
  ignoreTrimWhitespace: false,
  renderControlCharacters: true,
  scrollbar: {
    vertical: 'hidden',
    horizontal: 'hidden',
    verticalScrollbarSize: 0,
    horizontalScrollbarSize: 0,
    alwaysConsumeMouseWheel: false
  },
  overviewRulerBorder: false,
  overviewRulerLanes: 0,
  wordWrap: 'on'
} as monaco.editor.IStandaloneEditorConstructionOptions

export const getMonacoOptions = (
  readOnly = false,
  compact = false
): monaco.editor.IStandaloneDiffEditorConstructionOptions => ({
  ...MONACO_COMMON_OPTIONS,
  readOnly,
  renderSideBySide: !compact
})
